import React from "react";
import { ReactComponent as TwitterLogo } from "../../assets/ShareButton/twitter.svg";
import { ReactComponent as FacebookLogo } from "../../assets/ShareButton/facebook.svg";
import { ReactComponent as TelegramLogo } from "../../assets/ShareButton/telegram.svg";
import "../../stylesheet/components/singlecomponents/ShareButtons.scss";

const ShareButtons: React.FC = () => {
  // const shareFb = () => {
  //   console.log(window.location.href);
  // };

  return (
    <div className="d-flex justify-content-between">
      <a
        href={"http://www.twitter.com/share?url=" + window.location.href}
        target="_blank"
      >
        <TwitterLogo className="share-button twitter" />
      </a>
      <a
        href={
          "https://facebook.com/sharer/sharer.php?u=" + window.location.href
        }
        target="_blank"
      >
        <FacebookLogo className="share-button fb" />
      </a>

      <a
        href={"https://t.me/share/url?url=" + window.location.href}
        target="_blank"
      >
        <TelegramLogo className="share-button telegram" />
      </a>
    </div>
  );
};

export default ShareButtons;
